import {
	AddLiveTagToStepRequest,
	CreateChecklistRequest,
	CreateChecklistResponse,
	CreateChecklistStepRequest,
	DeleteChecklistStepRequest,
	RemoveLiveTagFromStepRequest,
	RemoveManualMeasurementPointFromStepRequest,
	UpdateChecklistStepRequest,
} from "@/components/Procedures/Types/ManualChecklistTypes";

import { DataAdapter } from "@/DataAdapter/DataAdapter";

export const CreateChecklist = async (request: CreateChecklistRequest) => {
	return DataAdapter.Post<CreateChecklistResponse>(`checklist`, request);
};

export const AddLiveTagToStep = async (request: AddLiveTagToStepRequest) => {
	return DataAdapter.Post(
		`checklistSteps/${request.StepId}/MeasurementTag`,
		request,
	);
};

export const CreateChecklistStep = async (
	request: CreateChecklistStepRequest,
) => {
	return DataAdapter.Post(`checklistSteps`, request);
};

export const UpdateChecklistStep = async (
	request: UpdateChecklistStepRequest,
) => {
	return DataAdapter.Patch(`checklistSteps/${request.StepId}`, request);
};

export const DeleteChecklistStep = async (
	request: DeleteChecklistStepRequest,
) => {
	return DataAdapter.Delete(`checklistSteps/${request.StepId}`, request);
};

export const RemoveLiveTagFromStep = async (
	request: RemoveLiveTagFromStepRequest,
) => {
	return DataAdapter.Delete(
		`checklistSteps/${request.StepId}/LiveTag`,
		request,
	);
};

export const RemoveManualMeasurementPointFromStep = async (
	request: RemoveManualMeasurementPointFromStepRequest,
) => {
	return DataAdapter.Delete(
		`checklistSteps/${request.StepId}/ManualMeasurementPoint`,
		request,
	);
};
